import { OM_ORDER_DETAIL_SLICE_NAME } from './core';
import { orderMgmtDetailReducer } from './ordermgmt-detail.slice';

export const OrderManagementDetailConfig = {
  name: OM_ORDER_DETAIL_SLICE_NAME,
  reducer: orderMgmtDetailReducer,
};
